import React from 'react';

import Input from './../Input';


const InstructorCode = (props) => (
    <Input label="辅导员工号" name="instructorCode" rules={[{ required: false}]} {...props}></Input>
);

export default InstructorCode;